var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31639_36822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4414 0.145508C5.37141 0.145508 0.441406 5.07551 0.441406 11.1455C0.441406 17.2155 5.37141 22.1455 11.4414 22.1455C17.5114 22.1455 22.4414 17.2155 22.4414 11.1455C22.4414 5.07551 17.5114 0.145508 11.4414 0.145508ZM11.4414 20.1455C6.48141 20.1455 2.44141 16.1055 2.44141 11.1455C2.44141 6.18551 6.48141 2.14551 11.4414 2.14551C16.4014 2.14551 20.4414 6.18551 20.4414 11.1455C20.4414 16.1055 16.4014 20.1455 11.4414 20.1455Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2005 12.4755L7.90047 10.1655L6.48047 11.5755L10.2005 15.3155L16.4005 9.10555L14.9805 7.68555L10.2005 12.4755Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31639_36822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    transform: "translate(0.441406 0.145508)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleOutline);
export default __webpack_public_path__ + "static/media/CheckCircleOutline.62ed7cfc86261181021d4f44f93a57e8.svg";
export { ForwardRef as ReactComponent };